<template>
    <!-- Sidebar: drawer off-canvas en móvil/tablet (< lg), fijo y colapsable en escritorio -->
    <aside aria-label="Menú principal"
        class="tw:fixed tw:inset-y-0 tw:left-0 tw:z-[1001] tw:lg:z-40 tw:bg-brand-background tw:text-slate-300 tw:flex tw:flex-col tw:shadow-xl tw:select-none tw:transition-[width,translate,visibility] tw:duration-300 tw:lg:translate-x-0 tw:lg:visible"
        :class="[expanded ? 'tw:w-70' : 'tw:w-20', mobileOpen ? 'tw:translate-x-0' : 'tw:-translate-x-full tw:invisible']"
        @mouseenter="setSidebarHovering(true)" @mouseleave="setSidebarHovering(false)">

        <!-- Cerrar drawer (solo móvil) -->
        <button type="button" aria-label="Cerrar menú" @click="closeMobileSidebar"
            class="tw:lg:hidden tw:absolute tw:top-3 tw:right-3 tw:z-10 tw:inline-flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:border-0 tw:bg-transparent tw:text-slate-300 tw:cursor-pointer tw:hover:bg-white/10 tw:hover:text-white">
            <i class="fas fa-times"></i>
        </button>

        <!-- Sidebar Brand Logo -->
        <div class="tw:flex tw:items-center tw:gap-3 tw:shrink-0 tw:border-b tw:border-brand-background/80 tw:bg-brand-background/50 tw:transition-all tw:duration-300 tw:shadow-lg"
            :class="expanded ? 'tw:h-40 tw:px-5' : 'tw:h-20 tw:px-2'">
            <router-link to="/admin/dashboard" @click.native="closeMobileSidebar"
                class="tw:flex tw:justify-center tw:flex-col tw:items-center tw:gap-3 tw:no-underline tw:w-full tw:min-w-0">
                <div :class="expanded ? 'tw:w-26 tw:h-26' : 'tw:w-16 tw:h-16'"
                    class="tw:rounded-xl tw:bg-brand-background/20 tw:border tw:border-primary/30 tw:flex tw:items-center tw:justify-center tw:overflow-hidden tw:shrink-0 tw:transition-all tw:duration-300">
                    <img src="/img/aliht.png" :alt="config.name || 'Logo'"
                        class="tw:w-full tw:h-full tw:object-cover tw:p-2 tw:max-w-full" />
                </div>
                <span v-show="expanded"
                    class="tw:font-bold tw:text-lg tw:text-slate-100 tw:truncate tw:max-w-full tw:tracking-tight">
                    {{ config.name || 'Panel Admin' }}
                </span>
            </router-link>
        </div>

        <!-- Scrollable Navigation -->
        <div v-if="showMenus" v-autohide-scrollbar
            class="tw:flex-1 tw:min-h-0 tw:overflow-y-auto tw:overflow-x-hidden tw:py-2 tw:scrollbar-autohide tw:[--scrollbar-thumb:rgba(255,255,255,0.2)]">
            <nav class="tw:p-3 tw:space-y-2">
                <SidebarItem v-for="item in visibleItems" :key="item.menu"
                    :title="ACCESS_MENU(item.menu).menu.title" :icon="ACCESS_MENU(item.menu).menu.icon"
                    :to="item.to" :routes="item.routes" :children="item.children" :expanded="expanded"
                    :open="openMenu && menuActive === item.menu" @toggle="toggleMenu(item.menu)" />

            </nav>
        </div>
    </aside>
    <!-- /Sidebar -->
</template>

<script>
import { ACCESS_MENU } from "@/validations/auth/AccessControlList";
import {
    isSidebarEffectivelyCollapsed, isMobileSidebarOpen, setSidebarHovering, closeMobileSidebar
} from '@/plugins/sidebarStore';
import menuConfig from './sidebar/menuConfig';
import SidebarItem from './sidebar/SidebarItem.vue';

export default {
    name: 'SideBar',
    components: { SidebarItem },
    data() {
        return {
            config: {},
            showMenus: false,
            openMenu: true,
            menuActive: null,
        };
    },
    computed: {
        expanded() {
            return !isSidebarEffectivelyCollapsed();
        },
        mobileOpen() {
            return isMobileSidebarOpen();
        },
        visibleItems() {
            return menuConfig.filter(item => ACCESS_MENU(item.menu));
        },
    },
    mounted() {
        setTimeout(() => {
            const config = JSON.parse(localStorage.getItem('configuration'));
            if (config !== undefined && config !== null) {
                this.config = config;
            }
            this.showMenus = true;
        }, 2000);
    },
    methods: {
        ACCESS_MENU,
        setSidebarHovering,
        closeMobileSidebar,
        toggleMenu(menu) {
            if (menu !== this.menuActive && this.openMenu === true) {
                this.menuActive = menu;
                return;
            }

            this.menuActive = menu;
            this.openMenu = !this.openMenu;
        }
    },
}
</script>
